export const DEFAULT_RACE_IMAGE = 'https://filestorage-prd.s3.eu-north-1.amazonaws.com/production/img/emails/defaultRaceImageV2.png';
export const SOCIAL_ICONS_COLORS = {
  gray: 'gray',
  aurora: 'aurora',
};
export const RACE_IMAGE_RATIO = 16 / 9;
